/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Proof_InfraInputs */

const en_cap_proof_infra = /** @type {(inputs: Cap_Proof_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI infrastructure`)
};

const lv_cap_proof_infra = /** @type {(inputs: Cap_Proof_InfraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI infrastruktūra`)
};

/**
* | output |
* | --- |
* | "AI infrastructure" |
*
* @param {Cap_Proof_InfraInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_proof_infra = /** @type {((inputs?: Cap_Proof_InfraInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Proof_InfraInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_proof_infra(inputs)
	return en_cap_proof_infra(inputs)
});